import { useTranslation } from "react-i18next";
import { OptionButtons } from "components/Form/OptionButtons";
import { ASSESSMENT_SUBJECT_SELF } from "components/Assessment/Subject";

export const HEALTH_STATUS_HEALTHY = 1;
export const HEALTH_STATUS_WITH_SICKNESS = 2;

export function AssessmentHealthStatus({
  assessmentSubject,
  defaultOption = null,
  className = "",
  onAnswer = () => {},
}) {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <p>{ t(
        (assessmentSubject.value === ASSESSMENT_SUBJECT_SELF)
          ? 'please enter your health status'
          : `please enter the health status of the assessment subject`
      ) }</p>
      <OptionButtons
        defaultOption={defaultOption}
        options={[
          { label: t("yes, i have"), value: HEALTH_STATUS_WITH_SICKNESS },
          { label: t("no, i have not"), value: HEALTH_STATUS_HEALTHY },
        ]}
        onSelect={(value) => onAnswer(value)}
      />
    </div>
  );
}

/**
 * Get the health status name
 *
 * @param {number} healthStatus
 * @returns {string}
 */
export function getHealthStatusName(healthStatus) {
  switch (healthStatus) {
    case HEALTH_STATUS_HEALTHY:
      return "healthy";
    case HEALTH_STATUS_WITH_SICKNESS:
      return "with sickness";
    default:
      return "";
  }
}

export default AssessmentHealthStatus;